import { AgTable } from '@navi/web-ui/lib/components';
import { Button } from '@primitives';
import { useNavigate } from 'react-router-dom';
import { ICellRendererParams } from 'ag-grid-community';
import APP_ROUTES from '@cp/src/layout/Routes';
import { GenericObject } from '@cp/src/types/CommonConstans';
import React, { useState } from 'react';
import Modal from '@cp/components/Modal/Modal';
import ReactJson from 'react-json-view';

type TriggersTableProps = {
  rowData: GenericObject[];
};
const TriggersTable = ({ rowData }: TriggersTableProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState<GenericObject>({});

  const columnDefs = [
    {
      headerName: 'Triggers Name',
      field: 'name'
    },
    {
      headerName: 'Description',
      field: 'description',
      autoHeight: true
    },
    {
      headerName: 'Status',
      field: 'status'
    },
    {
      headerName: '',
      field: '',
      cellRenderer: (params: ICellRendererParams) => (
        <Button
          variant="secondary"
          size="small"
          onClick={() => {
            setIsModalOpen(true);
            setModalContent(params.data);
          }}
        >
          View details
        </Button>
      )
    }
  ];
  return (
    <>
      <AgTable
        defaultColDef={{
          suppressMovable: true,
          wrapText: true
        }}
        gridOptions={{ suppressCellSelection: true }}
        sizeColumnsToFit={true}
        className="triggerTable"
        rowData={rowData || []}
        columnDefs={columnDefs}
        domLayout="autoHeight"
      />
      <Modal
        iconButtonSize="small"
        headerClassName="bg-[#f1f9f9] rounded"
        contentClassName="w-[800px] h-[600px] overflow-auto mx-[20px] my-[20px]"
        visible={isModalOpen}
        header={'Strategy'}
        onClose={() => setIsModalOpen(false)}
      >
        <ReactJson src={modalContent} name={modalContent[0]?.name} />
      </Modal>
    </>
  );
};

export default TriggersTable;
